import styled from 'styled-components';
import { styleVariables } from '../constants';

const BannerRootElement = styled.div`
    width:100%;
    padding: 55px 0;
    background: url(${'/support/partners/images/hero-banner-profile.png'}) right 0 no-repeat ${styleVariables.inkOnBackground};
    @media (max-width: 767px) {
       padding: 30px 0;
    }
    @media (max-width: 991px) {
      background-position: 66% 0;
    }
    @media (max-width: 767px) {
      background: #000;
    }
    .banner-title{
        color: ${styleVariables.background} !important;
        margin-bottom:18px;
    }
    .sub-title{
      color: ${styleVariables.background}!important;
      font-family: ArtifaktElement,Arial,sans-serif;
      margin-bottom:36px;
      @media (max-width: 767px) {
        margin-bottom:24px;
      }
    }
    .dhig-theme--dark{
      background:none;
    }
    .contact-bt{
      &:hover{
        background-color: #fff;
      }
    }
`;
export default BannerRootElement;
